import Button from "../../../components/bootstrap/Button";
import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import SubHeader, { SubHeaderLeft } from "../../../layout/SubHeader/SubHeader";
import { appMenu } from "../../../menu";
import { CommonAnsweredSurveyDetail } from "./Common/CommonAnsweredSurveyDetail";

const AnsweredSurveyDetailPage = () => {
    return (
        <PageWrapper title='Detalhes do questionário respondido'>
            <SubHeader>
                <SubHeaderLeft>
                    <Button
                        color='info'
                        isLink
                        icon='ArrowBack'
                        tag='a'
                        to={`../${appMenu.operations.subMenu.surveys.path}`}>
                        Voltar
                    </Button>
                </SubHeaderLeft>
            </SubHeader>
            <Page container='fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <CommonAnsweredSurveyDetail />
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default AnsweredSurveyDetailPage;